/**
 * Empty stand-in for Node built-ins that browser-targeted dependencies probe
 * for at runtime (see the `stream` / `fs` aliases in vite.config.ts).
 *
 * `xlsx-js-style` does `(require('stream') || {}).Readable` and looks for
 * `fs.writeFileSync` before falling back to a browser download. Vite's default
 * externalisation stub satisfies those checks but logs a warning on every
 * property access; resolving to a real empty module keeps the same behaviour
 * without the console noise.
 */
export default {};
